import PropTypes from 'prop-types';
import React from 'react';
import { Transition } from 'react-transition-group';

const TransitionWrapper = ({
  visible,
  component: Component,
  passedProps,
  ignoreTransition,
}) => {
  const disabledTransitions = ignoreTransition
    ? { enter: false, exit: false }
    : {};

  return (
    <Transition
      in={visible}
      mountOnEnter
      timeout={{ enter: 50, exit: 250 }}
      unmountOnExit
      {...disabledTransitions}
    >
      {(state) => <Component {...passedProps} transition={state} />}
    </Transition>
  );
};

TransitionWrapper.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
  ignoreTransition: PropTypes.bool,
  passedProps: PropTypes.shape({}),
  visible: PropTypes.bool,
};

TransitionWrapper.defaultProps = {
  ignoreTransition: false,
  passedProps: {},
  visible: false,
};

export default TransitionWrapper;
